<section class="link-list-section container px-0">
  <h2 class="link-list-section__title h1-md" *scText="title()"></h2>

  <div class="link-list--grid" [attr.link-lists]="linkLists().length">
    @for (linkList of linkLists(); track linkList.id) {
      <wl-link-list
        [id]="linkList.id"
        [title]="linkList.title"
        [linkList]="linkList.links"
        class="w-100"
      />
    }
  </div>
</section>
